import CarLayout2Container from "../../../components/car/detail/CarLayout2";

const CarLayout2 = () => {
  return <CarLayout2Container />;
};

export default CarLayout2;
